module.exports = __webpack_public_path__ + "static/media/0016.7a00abe5.jpg";